import Button from '@material-ui/core/Button';
import Card from '../../../../components/Card/CardTS';
import CardBody from '../../../../components/Card/CardBody.js';
import CardHeader from '../../../../components/Card/CardHeader.js';
import CardIcon from '../../../../components/Card/CardIcon.js';
import React, {useEffect} from 'react';
import regularFormsStyle from '../../../../assets/jss/material-dashboard-pro-react/views/regularFormsStyleTS';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { useState} from 'react';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import { deleteUser } from '../../../stores/actions/installerActions';
import { connect } from 'react-redux';
import Person from '@material-ui/icons/Person';
import { Account } from '../../../helpers/interfaces';
import Autocomplete from '@material-ui/lab/Autocomplete';
import SweetAlert from 'react-bootstrap-sweetalert';
import { sweetAlertStyle } from '../../../helpers/CustomStyles';
import RemoveUserConfirmationCard from '../../../components/RemoveUserConfirmationCard/RemoveUserConfirmationCard';
import _ from 'lodash';
import '../InstallerPanel.css';

interface IDeleteUserProps {
    classes: ClassNameMap;
    mobileView: boolean;
    deleteUserSucceeded: boolean;
    deleteUser: (userID) => void;
    accounts: Account[];
}

const DeleteUser = ({
    mobileView,
    deleteUser,
    accounts,
    deleteUserSucceeded,
    ...props
}: IDeleteUserProps) => {
    const { classes } = props;
	const [pickedAccount, setPickedAccount] = useState<string|null|undefined>(null);
    const accountIdsByNames = Object.fromEntries(accounts.map(x => [`${x.name} (${x.email})`, x.id]));
    const accountOptions = accounts
        .filter((account) => account.accountCategory === "commoner")
        .sort((a, b) => (a.name.toUpperCase() > b.name.toUpperCase()) ? 1 : -1)
        .map((account) => `${account.name} (${account.email})`);
    const [confirmationWindow, setConfirmationWindow] = useState<any>(null);
    const handleDeleteUser = (): void => {
        if (pickedAccount) {
            showRemoveSystemConfirmation();
        }
    }
     
	useEffect(() => {
        setPickedAccount(null);
	}, [deleteUserSucceeded]);

 
    const deleteButton = (): JSX.Element => {
        return (
            <Button
                size='medium'
                style={{ marginTop: '25px', transition: 'color 0.3s' }}
                disabled={!pickedAccount}
                onClick={(e) => { handleDeleteUser() }}
            >
                Delete
            </Button>
        );
    };
	const hideRemoveUserConfirmation = () => {
		setConfirmationWindow(null);
	};

	const showRemoveSystemConfirmation = (): void => {
        if (!pickedAccount) {
            return;
        }
        const accountId = accountIdsByNames[pickedAccount];
        const account =  _.filter(accounts, { id: accountId })[0];
		setConfirmationWindow(
			<SweetAlert
				title=''
				showConfirm={false}
				style={sweetAlertStyle}
				onConfirm={hideRemoveUserConfirmation}
				onCancel={hideRemoveUserConfirmation}
				key='remove-user-confirmation-alert'
			>
				<RemoveUserConfirmationCard account={account} hideRemoveUserConfirmation={hideRemoveUserConfirmation} />
			</SweetAlert>
		);
	};

    if (accounts.length < 1) {
        return (
            <Card>
                <CardHeader color='info' icon>
                    <CardIcon color='info'>
                        <Person />
                    </CardIcon>
                    <h4 className={classes.cardIconTitle}>
                        Delete User
                    </h4>
                </CardHeader>
                <CardBody>No users yet.</CardBody>
            </Card>
        );
    }

    return (
        <>
        {confirmationWindow}
        <Card className='inviteUserForm'>
            <CardHeader color='info' icon>
                <CardIcon color='info'>
                    <Person />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>Delete User</h4>
            </CardHeader>
            <CardBody>
                <FormControl fullWidth className={classes.selectFormControl} onSubmit={(e) => e.preventDefault()}>
                    <div style={{ width: '100%' }}>
                    <Autocomplete
                            options={accountOptions}
                            getOptionLabel={(account) => account}
                            id='account-name'
                            value={pickedAccount}
                            onChange={(event, newValue) => setPickedAccount(newValue)}
                            renderInput={(accounts) => <TextField {...accounts} label='Account' margin='normal' />}
                            style={{ width: '100%' }}
                        />
                    </div>
                </FormControl>
                {deleteButton()}
            </CardBody>
        </Card>
        </>
    );
};

const mapStateToProps = (state) => ({
    accounts: state.dashboard.accounts,
    mobileView: state.dashboard.mobileView,
    deleteUserSucceeded: state.installer.deleteUserSucceeded
});
const actions = {
    deleteUser
};

const DeleteUserWithStyles = regularFormsStyle(DeleteUser);
export default connect(mapStateToProps, actions)(DeleteUserWithStyles);
